import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import colorSharp from "../assets/img/color-sharp.png";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Skills</h2>
              <p>
               Throughout a series of intensive projects, I have gained hands-on mastery of a modern, production-ready tech stack. I integrate generative AI using Google Gemini, OpenAI, Cohere, and Hugging Face APIs with advanced prompt engineering techniques. On the low-code side, I build full-featured business applications with Microsoft Power Apps, Power Automate, and Power Fx, connected to SharePoint, Excel, and Dataverse. For data engineering, I design and implement robust ETL pipelines in Python (pandas, SQLAlchemy), write complex SQL queries (joins, CTEs, window functions), and work with PostgreSQL, MySQL, AWS S3, and Azure Blob Storage. I containerize applications with Docker, orchestrate them using Kubernetes (deployments, services, ingress), and automate the entire workflow through CI/CD pipelines in GitHub Actions. On the cloud front, I deploy and manage infrastructure across AWS (EC2, Lambda, S3, RDS, IAM, CodePipeline, Elastic Beanstalk) and Azure (App Service, SQL Database, DevOps Pipelines). Front-end work includes clean, responsive interfaces built with HTML, CSS (Tailwind), JavaScript, and FastAPI backends. I follow Agile methodologies with Jira/Trello boards and maintain clean, collaborative codebases using Git and GitHub with proper branching strategies. This diverse, end-to-end skill set enables me to deliver intelligent, scalable, and cloud-native solutions from concept to production.
              </p>

              <Carousel
                responsive={responsive}
                infinite={true}
                className="owl-carousel owl-theme skill-slider"
              >
                 <div className="item">
                  <img src="https://cdn.simpleicons.org/html5/E34F26" alt="" />
                  <h5>HTML</h5>
                </div>

                <div className="item">
                  <img src="https://cdn.simpleicons.org/windows/4A90E2" alt="" />
                  <h5>Web Development</h5>
                </div>

                <div className="item">
                  <img src="https://cdn.simpleicons.org/javascript/F7DF1E" alt="" />
                  <h5>JavaScript</h5>
                </div>


                <div className="item">
                  <img src="https://cdn.simpleicons.org/css3/1572B6" alt="" />
                  <h5>CSS</h5>
                </div>

                

                <div className="item">
                  <img src="https://cdn.simpleicons.org/python/3776AB" alt="" />
                  <h5>Python</h5>
                </div>

                
                <div className="item">
                  <img src="https://cdn.simpleicons.org/powerbi/F2C811" alt="" />
                  <h5>Power BI</h5>
                </div>

                <div className="item">
                  <img src="https://cdn.simpleicons.org/mysql/4479A1" alt="" />
                  <h5>SQL</h5>
                </div>

                <div className="item">
                  <img src="https://cdn.simpleicons.org/github/181717" alt="" />
                  <h5>GitHub</h5>
                </div>

                <div className="item">
                  <img src="https://cdn.simpleicons.org/fastapi/009688" alt="" />
                  <h5>FastAPI</h5>
                </div>

                <div className="item">
                  <img src="https://cdn.simpleicons.org/git/F05032" alt="" />
                  <h5>Git</h5>
                </div>

                

                <div className="item">
                  <img src="https://cdn.simpleicons.org/scrumalliance/29A9E1" alt="" />
                  <h5>Agile Development</h5>
                </div>

                  <div className="item">
                  <img src="https://cdn.simpleicons.org/microsoftazure/0078D4" alt="" />
                  <h5>Azure</h5>
                </div>

                <div className="item">
                  <img src="https://cdn.simpleicons.org/docker/2496ED" alt="" />
                  <h5>Docker</h5>
                </div>

                <div className="item">
                  <img src="https://cdn.simpleicons.org/amazonaws/FF9900" alt="" />
                  <h5>AWS</h5>
                </div>


                <div className="item">
                  <img src="https://cdn.simpleicons.org/kubernetes/326CE5" alt="" />
                  <h5>Kubernetes</h5>
                </div>


                <div className="item">
                  <img src="https://cdn.simpleicons.org/powerapps/742774" alt="" />
                  <h5>Microsoft Power Apps</h5>
                </div>

                <div className="item">
                  <img src="https://cdn.simpleicons.org/openai/412991" alt="" />
                  <h5>AI & LLMs</h5>
                </div>

                
                <div className="item">
                  <img src="https://cdn.simpleicons.org/microsoftpowerautomate/0066FF" alt="" />
                  <h5>Power Automate</h5>
                </div>

                <div className="item">
                  <img src="https://cdn.simpleicons.org/apacheairflow/017CEE" alt="" />
                  <h5>Data Engineering</h5>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>

      <img className="background-image-left" src={colorSharp} alt="decor" />
    </section>
  );
};
